import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { FileType } from '../../types/common.types';
import { DownloadDocumentRequest, UploadDocumentRequest, UploadDocumentsRequest } from './document.types';

import { requestDownloadDocument, requestUploadDocument, requestUploadDocuments } from './document.actions';

export const useDocumentApi = () => {
  const dispatch = useDispatch();

  const downloadDocument = useCallback(
    (requestData: DownloadDocumentRequest, onSuccess: (data: ArrayBuffer) => void) => {
      dispatch(requestDownloadDocument({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const uploadDocument = useCallback(
    (requestData: UploadDocumentRequest, onSuccess: (documentExternalReference: string) => void) => {
      dispatch(requestUploadDocument({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const uploadDocuments = useCallback(
    (requestData: UploadDocumentsRequest, onSuccess: (documentExternalReferences: FileType[]) => void) => {
      dispatch(requestUploadDocuments({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return {
    downloadDocument,
    uploadDocument,
    uploadDocuments
  };
};
